import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { CashFlowElements } from './CashFlowElements';
import { FinancialPerformance } from './FinancialPerformance';
import { KeyAssumptions } from './KeyAssumptions';
import { OpeningBalanceSheets } from './OpeningBalanceSheets';
import { PlannedExpenses } from './PlannedExpenses';
import { ProfitAndLossProjection } from './ProfitAndLossProjection';
import { ProjectedBalanceSheets } from './ProjectedBalanceSheets';
import { ProjectedCashFlow } from './ProjectedCashFlow';
import { RevenuePlan } from './RevenuePlan/RevenuePlan';

export const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.KEY_ASSUMPTIONS]: KeyAssumptions,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.REVENUE_PLAN]: RevenuePlan,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PLANNED_EXPENSES]: PlannedExpenses,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PROFIT_AND_LOSS_PROJECTION]: ProfitAndLossProjection,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.CASH_FLOW_ELEMENTS]: CashFlowElements,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.FINANCIAL_PERFORMANCE]: FinancialPerformance,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.OPENING_BALANCE_SHEETS]: OpeningBalanceSheets,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PROJECTED_BALANCE_SHEETS]: ProjectedBalanceSheets,
  [BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PROJECTED_CASH_FLOW]: ProjectedCashFlow,
};

export const FinancialPlan: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
